export default __webpack_public_path__ + "static/media/final.be74a2b1.jpg";